import generateBasicEntityActions from './generateBasicEntityActions';

const myClientActions = generateBasicEntityActions('clients', 'client', 'me/clients');

export default myClientActions;
